import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { WidgetId } from '../../../../api/useWidgetsQuery';
import { TabSlug } from '../../../../types';
import { GroupSelection } from '../../../GroupSelection/GroupSelection';
import { IncomeDetails } from '../../../IncomeDetails/IncomeDetails';

interface Props {
  title: string;
  id: WidgetId;
}

export const IncomeDetailsCard = React.memo(({ title, id }: Props) => {
  return (
    <Box>
      <GroupSelection id={id} tabSlug={TabSlug.Income} />

      <IncomeDetails title={title} />
    </Box>
  );
});
